/* eslint-disable max-len */
const BYNDER_URL_PREFIX = 'https://cam.scentregroup.io/m/';
const CLOUDINARY_URL_PREFIX = 'https://res.cloudinary.com/';
const CLOUDINARY_URL_POSTFIX = '/video/upload/';
const CLOUDINARY_MAPPED_FOLDER = '/cinematograph_media/';
const DESKTOP_OPTIONS = 'vc_h264,c_fill,g_center,h_1028,w_2400';
const MOBILE_OPTIONS = 'vc_h264,c_fill,g_center,h_426,w_640';
const SQUARE_OPTIONS = 'vc_h264,f_mp4,c_fill,g_center,h_1024,w_1024';
const WIDE_OPTIONS = 'vc_h264,f_mp4,c_fill,g_center,ar_21:9,w_2048';
export let DeviceType = /*#__PURE__*/function (DeviceType) {
  DeviceType["mobile"] = "mobile";
  DeviceType["desktop"] = "desktop";
  DeviceType["square"] = "square";
  DeviceType["wide"] = "wide";
  return DeviceType;
}({});
const stripOutBynderUrl = url => url.replace(BYNDER_URL_PREFIX, '');
const getOptionsByDeviceType = deviceType => {
  switch (deviceType) {
    case DeviceType.square:
      return SQUARE_OPTIONS;
    case DeviceType.wide:
      return WIDE_OPTIONS;
    case DeviceType.desktop:
      return DESKTOP_OPTIONS;
    default:
      return MOBILE_OPTIONS;
  }
};
export const cloudinaryVideoUrl = _ref => {
  let {
    baseUrl,
    deviceType,
    cloudName = 'scentre-group-au',
    removeAudio = false
  } = _ref;
  const url = stripOutBynderUrl(baseUrl);
  let options = getOptionsByDeviceType(deviceType);
  if (removeAudio) {
    options += ',ac_none';
  }
  return "".concat(CLOUDINARY_URL_PREFIX).concat(cloudName).concat(CLOUDINARY_URL_POSTFIX).concat(options).concat(CLOUDINARY_MAPPED_FOLDER).concat(url);
};
export const videoSrcFromSGPageTemplateImage = (templateImage, deviceType) => {
  const {
    cinemagraphUrl
  } = templateImage;
  if (!cinemagraphUrl) {
    return undefined;
  }
  return cloudinaryVideoUrl({
    baseUrl: cinemagraphUrl,
    removeAudio: true,
    deviceType: deviceType !== null && deviceType !== void 0 ? deviceType : DeviceType.square
  });
};